<!-- Renders the shared chat shell; contractId carries the geotechnical analysis ID -->
<app-chat-tab-shell [contractId]="contractId()" />
